<template>
    <v-layout pa-0 ma-0 row justify-space-between v-if="device && device.state">
        <v-flex xs6 class="d-inline-flex align-center">
            <div v-if="showLocation" class="location-row text-left ma-0"> {{device.location}} </div>
        </v-flex>
        <v-flex xs6 class="d-inline-flex justify-end align-center">
            <v-tooltip
                top
                content-class="arrow-down"
                v-model="showBattery"
                v-if="device.power == 'battery' && device.state.battery != null"
            >
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="d-inline-flex"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="showBattery = true"
                    >
                        <v-img max-height="24px" max-width="24px" :src="require(`@/assets/icons/battery/${power}.svg`)"></v-img>
                    </div>
                </template>
                <span class="main-text">{{device.state.battery}}%</span>
            </v-tooltip>
            <v-img
                v-else-if="device.power == 'mains'"
                max-height="20px"
                max-width="20px"
                :src="require(`@/assets/icons/plug.svg`)"
            ></v-img>
            <v-tooltip top content-class="arrow-down" v-model="show">
                <template v-slot:activator="{ on, attrs }">
                    <div
                        class="d-inline-flex"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop.prevent="show = true"
                    >
                        <div class="status-marker ml-2">
                            <div :class="device.online ? 'green-color' : 'red-color'"></div>
                        </div>
                    </div>
                </template>
                <span class="main-text">{{device.online ? "online" : "offline"}}</span>
            </v-tooltip>
            <div v-if="edit" class="close-btn ml-2" @click.stop.prevent="openEditPage">
                <v-img max-height="18px" max-width="18px" :src="require('@/assets/icons/edit_icon.svg')" class="d-inline-flex"/>
            </div>
            <div v-if="edit" class="close-btn" @click.stop.prevent="openModalDelete">
                <v-img :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
            </div>
        </v-flex>
        <ModalDeleteConfirm
            v-model="modalDelete"
            :close="closeModalDelete"
            :url="`/devices/hotel-admin/devices/${device.uid}/`"
        >
            <template #deleteTitle>
                Вы действительно хотите удалить <br> устройство?
            </template>
            <template #deleteSubtitle>
                После удаления устройство<br>
                <span class="common-text">{{device.name}}</span><br>
                пропадёт из списка устройств
            </template>
        </ModalDeleteConfirm>
    </v-layout>
</template>

<script>
import ModalDeleteConfirm from "@/components/modals/ModalDeleteConfirm";

export default {
    name: "DeviceStatus",
    components: {ModalDeleteConfirm},
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        edit: {
            type: Boolean,
            default: false,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: false,
            showBattery: false,
            modalDelete: false,
            room: null,
        };
    },
    created() {
        this.room = this.$route.params.id;
    },
    computed: {
        power() {
            if (this.device.state && this.device.power == "battery") {
                return this.device.state.battery < 21 ?
                    "battery_empty" : this.device.state.battery < 41 ?
                        "battery_low" : this.device.state.battery < 71 ?
                            "battery_middle" : !this.device.state.battery ?
                                "battery_unknown" : "battery_high";
            }
        },
    },
    methods: {
        openModalDelete() {
            this.modalDelete = true;
        },
        closeModalDelete() {
            this.modalDelete = false;
        },
        openEditPage() {
            this.$router.push({
                name: "devicepage",
                params: { id: this.device.controller },
                query: { zigbee: this.device.inner_name, device: this.device.uid },
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.status-marker {
    align-items: center;
    display: inline-flex;

    .green-color,
    .red-color {
        height: 12px;
        width: 12px;
        border-radius: 6px;
    }

    .green-color {
        background: #42D829;
    }

    .red-color {
        background: #FF4F4F;
    }
}

.v-tooltip__content {
    background: linear-gradient(180deg, #FFF4BC 0%, rgba(255, 132, 132, 0.8) 100%);
    border-radius: 30px;
    padding: 16px;

    &.menuable__content__active {
        opacity: 1;

        &.arrow-down {
            overflow: inherit !important;
            z-index: 7;

            &::before {
                content: '';
                position: absolute;
                left: 50%;
                top: 100%;
                border: 5px solid #FF8484;
                border-color: #FF8484 transparent transparent transparent;
                opacity: 0.8;
            }
        }
    }
}
</style>